var _mask, _rect, _rect2, _line, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_7_6125",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 2.5332,
    width: 17.8127,
    height: 21.4366,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2.5332,
    width: 17.8127,
    height: 21.4366,
    rx: 1,
    stroke: "#333333",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_7_6125)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.27539,
    y: 1,
    width: 7.26251,
    height: 4.56152,
    rx: 1,
    fill: "#003D4C",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.30078,
    y1: 8.15527,
    x2: 13.5124,
    y2: 8.15527,
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.30078,
    y1: 11.9839,
    x2: 13.5124,
    y2: 11.9839,
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.30078,
    y1: 15.8125,
    x2: 13.5124,
    y2: 15.8125,
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4.30078,
    y1: 19.6411,
    x2: 13.5124,
    y2: 19.6411,
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductListIcon);
export default __webpack_public_path__ + "static/media/product-list-icon.1133a98d9e82dba2f3319729f27755e0.svg";
export { ForwardRef as ReactComponent };